import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Pizza } from '../types';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../lib/firebase';

interface PizzaCardProps {
  pizza: Pizza;
}

export default function PizzaCard({ pizza }: PizzaCardProps) {
  const [visiblePizzeriaCount, setVisiblePizzeriaCount] = useState(0);

  useEffect(() => {
    const countVisiblePizzerias = async () => {
      try {
        // Prima contiamo le pizzerie che hanno questa pizza nel menu dinamico
        const menuRef = collection(db, 'pizzeinmenu');
        const menuQuery = query(
          menuRef,
          where('pizzaId', '==', pizza.id),
          where('isHidden', '==', false)
        );
        const menuSnapshot = await getDocs(menuQuery);
        const dynamicCount = new Set(menuSnapshot.docs.map(doc => doc.data().pizzeriaId)).size;

        if (dynamicCount > 0) {
          // Se la pizza è presente in menu dinamici, usiamo solo quel conteggio
          setVisiblePizzeriaCount(dynamicCount);
        } else {
          // Altrimenti contiamo le pizzerie che hanno la pizza nel menu statico
          const pizzeriasSnapshot = await getDocs(collection(db, 'pizzerie'));
          const staticCount = pizzeriasSnapshot.docs.reduce((acc, doc) => {
            const pizzeria = doc.data();
            // Conta la pizzeria solo se ha la pizza nel menu statico E non l'ha nascosta
            if (pizzeria.pizzas?.includes(pizza.id) && !pizzeria.hiddenPizzas?.includes(pizza.id)) {
              return acc + 1;
            }
            return acc;
          }, 0);
          setVisiblePizzeriaCount(staticCount);
        }
      } catch (error) {
        console.error('Errore nel conteggio delle pizzerie:', error);
      }
    };

    countVisiblePizzerias();
  }, [pizza.id]);

  return (
    <Link to={`/pizze/${pizza.id}`} className="block">
      <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105">
        <img
          src={pizza.imageUrl}
          alt={pizza.name}
          className="w-full h-48 object-cover"
        />
        <div className="p-4">
          <h3 className="text-lg font-semibold text-gray-900">{pizza.name}</h3>
          <p className="mt-1 text-gray-600 text-sm line-clamp-2">
            {pizza.description}
          </p>
          <div className="mt-2">
            <p className="text-sm text-gray-500">
              Disponibile in {visiblePizzeriaCount} {visiblePizzeriaCount === 1 ? 'pizzeria' : 'pizzerie'}
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
}